import {Text} from '@sanity/ui'
import {styled} from 'styled-components'

export const EmojiText = styled(Text)`
  font-family:
    'Twemoji Mozilla', 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji',
    'EmojiOne Color', 'Android Emoji', sans-serif;
`
